import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page89() {
  useEffect(() => {
    document.title = "Маяк — Страница 88"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page87" />
        <ForwardLink href="/page89" />
      </div>

      <p style={{ textAlign: "right" }}>88.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Работаю за человека и двух<br/>
        лошадей, ты сам так сказал, я работаю<br/>
        как чертов гастарбайтер.
      </p>
      <p>
        МОЛОДОЙ пытается попасть в ПЕРЕХОД к БАШНЕ.<br/>
        СТАРИК стоит у него на пути.
      </p>
      <p>МОЛОДОЙ отчаянно просит:</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Пожалуйста, пожалуйста, пусти меня<br/>
        к свету, старик, и я покажу тебе,<br/>
        что я могу сделать -- я могу... я могу<br/>
        лучше... я могу. Я так многому<br/>
        научился у тебя. Еще один шанс. Позволь<br/>
        мне показать тебе. Прости и забудь,<br/>
        говорю, -- просто пусти меня<br/>
        к фонарю, вот и все, не заставляй меня умолять--<br/>
        я буду -- я буду умолять, если ты<br/>
        этого хочешь, ПОЖАЛУЙСТА--
      </p>
      <p>СТАРИК стоит на своем.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Отойди.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        ЭГОИСТИЧНЫЙ УБЛЮДОК! Держишь все это<br/>
        при себе. Оставил свою старушку<br/>
        и детей, ради чего? Ради чего?!
      </p>
      <p>СТАРИК улыбается. Жутко.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Посмотри на себя, красавчик, с глазами<br/>
        блестящими как у леди. Приплыл на этот камень,<br/>
        играя суровость, ты заставил меня смеяться<br/>
        своим фальшивым ворчанием. Ты притворялся<br/>
        таинственным в своем молчании,<br/>
        но никакой тайны нет, ты<br/>
        открытая книга. Картинка, говорю я.<br/>
        Разрисованная актриса, кричащая<br/>
        в свете рампы, сука, которая хочет,<br/>
        чтобы ее желали только за то, что она<br/>
        родилась и плачет из-за богатства,<br/>
        которое ей не досталось. А теперь посмотри<br/>
        на себя, как ты плачешь.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        --
      </p>
      <p style={{ textAlign: "right" }}>88.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page87" />
        <ForwardLink href="/page89" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710718148/the-lighthouse-script/zo7izo704vfeqyaxs4vy.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page89;
